import React from 'react'
function SecondTextInputComponent({
    label,
    inputPlaceHolder,
    inputValue,
    onChangeValue,
    inputError,
    inputType,
    colSpan = "col-span-1",
  }) {
  return (
    <div className={`mx-2 mt-2 ${colSpan}`}>
    <h2 className="mb-1 font-bold text-slate-800">{label}</h2>
    <input
      className={`${
        inputType !== "date" && "py-1.5"
      } w-full rounded-sm border border-slate-500 focus:outline-blue-600 ${
        inputError && "border-red-600 focus:outline-red-600 bg-red-100"
      }`}
      placeholder={inputPlaceHolder}
      value={inputValue}
      onChange={(e) => onChangeValue(e.target.value)}
      type={inputType}
    />
    <h2 className="text-xs text-[#ff0000]">{inputError}</h2>
  </div>
  )
}

export default SecondTextInputComponent